function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "clip-Artboard_1"
}, React.createElement("rect", {
  width: 36,
  height: 33
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Artboard_1",
  "data-name": "Artboard \\u2013 1",
  clipPath: "url(#clip-Artboard_1)"
}, React.createElement("rect", {
  width: 36,
  height: 33,
  fill: "#fff"
}), React.createElement("g", {
  id: "Group_349",
  "data-name": "Group 349",
  transform: "translate(-0.317)"
}, React.createElement("g", {
  id: "iconfinder_Streamline-18_185038",
  transform: "translate(0 0)"
}, React.createElement("g", {
  id: "Group_7",
  "data-name": "Group 7"
}, React.createElement("g", {
  id: "Group_4",
  "data-name": "Group 4",
  transform: "translate(4.829 17.506)"
}, React.createElement("path", {
  id: "house_1",
  "data-name": "Path 12",
  d: "M32.159,41.494H6V26.7a.727.727,0,0,1,1.453,0V40.085H30.706V27.409a.727.727,0,0,1,1.453,0Z",
  transform: "translate(-6 -26)",
  fill: "#707070",
  stroke: "#707070",
  strokeWidth: 0.5
})), React.createElement("g", {
  id: "Group_5",
  "data-name": "Group 5"
}, React.createElement("path", {
  id: "house_2",
  "data-name": "Path 13",
  d: "M35.071,22.242a.716.716,0,0,1-.516-.223L17.909,4.844,1.262,22.019a.709.709,0,0,1-1.055-.025A.851.851,0,0,1,.23,20.856L17.909,2.616,35.587,20.855a.851.851,0,0,1,.023,1.138A.718.718,0,0,1,35.071,22.242Z",
  transform: "translate(0 -2.616)",
  fill: "#707070",
  stroke: "#707070",
  strokeWidth: 0.5
})))), React.createElement("path", {
  id: "house_3",
  "data-name": "Path 15",
  d: "M35.5,178l7.5-9.583,3.333,3.333L51.75,163",
  transform: "translate(-26.433 -150)",
  fill: "none",
  stroke: "#707070",
  strokeWidth: 2
})));

var SvgHouse = function SvgHouse(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 36,
    height: 33,
    viewBox: "0 0 36 33",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgHouse, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/house.4d8050fa.svg";
export { ForwardRef as ReactComponent };